import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { result } from "lodash";

const INIT_STATE = {
    units: [],
    searchUnitsResult: null,
    selectedDevices: [],
    result: null,
    openModal: false,
    loadingBillingAccounts: false,
    error: null
};
// Async thunk to search units (simulate API call)
export const searchUnits = createAsyncThunk('assignBillingAccount/searchUnits', async (searchTerm, { rejectWithValue }) => {
    try {
        let response = await clientQuery(`
                query searchUnits($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                    result: searchUnits(conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            label
                            esn
                            imei
                        }
                        total
                    }
                }`,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: [searchTerm],
                    exact: true
                },
                limit: 1,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL
        );
        return response?.result;
    } catch (error) {
        return rejectWithValue(error.message);
    }
}
);

export const assignBillingAccountToUnits = createAsyncThunk("dealers/views/.components/assignBillAccount/redux/slice/assignBillingAccountToUnits", async (payload, { rejectWithValue, dispatch }) => {
    const { billingAccountId, unitIds } = payload;
    try {
        let response = await clientMutation(`
            mutation assignBillingAccountToUnits($billingAccountId: Int, $unitIds: [Int]!) {
                result: assignBillingAccountToUnits(billingAccountId: $billingAccountId, unitIds: $unitIds)
            }`,
            {
                billingAccountId: billingAccountId,
                unitIds: unitIds
            },
            endpoints.GRAPHQL_GENERAL
        );
        return { result: response?.result };
    } catch (exc) {
        return rejectWithValue(exc);
    }
}
)

const assignBillingAccountRedux = createSlice({
    name: 'dealers/billingAccount/createEditBillingAccount',
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : { ...INIT_STATE }
        },
        openModalAssignBillingAccount(state, action) {
            state.openModal = true
            state.selectedDevices = action.payload.selectedDevices || [];
        }
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(searchUnits.pending, (state) => {
                state.loadingBillingAccounts = true;
                state.error = null;
            })
            .addCase(searchUnits.fulfilled, (state, action) => {
                state.loadingBillingAccounts = false;
                state.searchUnitsResult = action.payload;
            })
            .addCase(searchUnits.rejected, (state, action) => {
                state.loadingBillingAccounts = false;
                state.error = action.payload;
            });
        builder
            .addCase(assignBillingAccountToUnits.pending, (state) => {
                state.loadingBillingAccounts = true;
                state.error = null;
            })
            .addCase(assignBillingAccountToUnits.fulfilled, (state, action) => {
                state.loadingBillingAccounts = false;
                state.result = action.payload?.result;
            })
            .addCase(assignBillingAccountToUnits.rejected, (state, action) => {
                state.loadingBillingAccounts = false;
                state.error = action.payload;
            });
    },
});
const { actions, reducer } = assignBillingAccountRedux;

export const {
    reset,
    openModalAssignBillingAccount
} = actions;

export default reducer;